import { css } from "@obby/components";

export const styles = {
  contactPage: css({
    backgroundColor: "#f0f0f0",
    padding: "$mdTop 0 50px",
    "@lg": {
      paddingTop: "@lg-top"
    }
  }),
  heading: css({
    textAlign: "center",
    fontFamily: "$foundersGroteskCondensed",
    fontSize: "$36",
    color: "$ebonyClay",
    lineHeight: "1",
    textTransform: "uppercase",
    "@md": {
      fontSize: "$36"
    },
    "@lg": {
      fontSize: "$40"
    }
  }),
  subheading: css({
    textAlign: "center",
    fontFamily: "$foundersGrotesk",
    fontSize: "20px",
    color: "$ebonyClay",
    lineHeight: "1",
    fontWeight: "normal",
    "@md": {
      fontSize: "24px"
    }
  }),
  section: css({
    padding: "50px 0 0"
  }),
  sectionTitle: css({
    fontFamily: "$foundersGroteskCondensed",
    fontSize: "$28",
    color: "$ebonyClay",
    lineHeight: "1",
    textTransform: "uppercase",
    "@lg": {
      fontSize: "$32"
    }
  }),
  sectionDescription: css({
    fontFamily: "$foundersGrotesk",
    fontSize: "$18",
    color: "$ebonyClay",
    "@lg": {
      fontSize: "20px"
    }
  })
};
